import { useMemo, useCallback, useState, useEffect } from 'react';
import { EditorPopup } from 'components/Editors/EditorPopup';
import { IEditorProps } from 'components/Editors//Editor';
import { getImageInfoUrl } from 'utils/ImageUtils';
import { ImageInfo } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Image';
import { DisplayImageInfo } from 'components/inputs/ImagePicker/DisplayImageInfo';

interface IImageInfoEditorProps extends IEditorProps {}

export function ImageInfoEditor(props: IImageInfoEditorProps) {
  const { path, onChange } = props;

  const [imageInfo, setImageInfo] = useState(props.child.Value && props.child.Value.OutputValue);
  const [imageUrl, setImageUrl] = useState<string | null>();
  const [imageName, setImageName] = useState();

  useEffect(() => {
    setImageInfo(props.child.Value && props.child.Value.OutputValue);
  }, [props.child.Value]);

  useEffect(() => {
    setImageName(imageInfo && (imageInfo.ImageName || imageInfo.ImageUrl));
    setImageUrl(getImageInfoUrl(imageInfo));
  }, [imageInfo]);

  // only updates image url and does not raise onchange event
  const updateImageInfo = useCallback((value: ImageInfo | null) => {
    setImageInfo(value);
  }, []);

  // updates image url and also raise onchange event
  const onValueChange = useCallback(
    (value: ImageInfo | null) => {
      updateImageInfo(value);
      onChange(value, path);
    },
    [onChange, path, updateImageInfo]
  );

  const options = useMemo(
    () => ({
      onOk: onValueChange,
      onClear: () => updateImageInfo(null),
    }),
    [onValueChange, updateImageInfo]
  );

  return (
    <EditorPopup {...props} dialogOptions={options}>
      <DisplayImageInfo imageUrl={imageUrl} imageName={imageName} />
    </EditorPopup>
  );
}
